import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeselectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"deselect"}/>
}
